export default {
  data() {
    return {
      technologyList: [{
        title: '语音合成'
      }, {
        title: '自然语言处理'
      }, {
        title: '机器翻译'
      }, {
        title: '图形识别'
      }],
      AiCardList: [{
        title: '语音合成',
        path: '/technology/TextToSpeech'
      }, {
        title: '文本翻译',
        path: '/technology/TextTranslation'
      }, {
        title: '摄像头人脸识别',
        path: '/technology/FaceRecognition'
      }, {
        title: '自动写文章',
        path: '/technology/AiWriter'
      }, {
        title: '金融文本审核',
        path: '/technology/FinancialTextReview'
      }, {
        title: '合同文档对比',
        path: '/technology/ContractComparison'
      }]
    };
  }
};